import React from "react";
// import { useError } from "../../store/error";
// import GenericMessageModal from "../generic-message-modal";

const ErrorBoundary: React.FC = () => {
  const showError = false;
  // const { error, showError, clearError, setShowStatus } = useError();

  return showError ? (
    // <GenericMessageModal
    //   type="error"
    //   description={error}
    //   show={showError}
    //   onClose={() => setShowStatus(false)}
    //   onDismiss={() => clearError()}
    // />
    <p>Under construction</p>
  ) : null;
};

export default ErrorBoundary;
